import { apiPcMcdFollowOrder } from '@/api/fetch-utils/pc-mcd-controller';
import { createFetchClient } from '@/lib/fetch-tools';
import { Input, Toast } from 'antd-mobile';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { contractApi } from '../../../../api/contract-api';
import { followApi } from '../../../../api/followup';
import DataEmpty from '../../../../components/dataempty';
import { getText } from '../../../../utils/util';
import { isShowOrderButton } from '../tradeBox';
import './index.css';

// startFollowOrder
export default function OrderList({ hyorders, nowTab }) {
  const [showCancelButton, setShowCancelButton] = useState(true);
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const tab = nowTab.toUpperCase() + '/USDT';
  const lan = localStorage.getItem('i18n');
  const [type, setType] = useState(0);
  const [orderCode, setOrderCode] = useState('');
  const requestPcMcdFollowOrder = createFetchClient(apiPcMcdFollowOrder);
  const uid = localStorage.getItem('uid');
  const [followOrders, setFollowOrders] = useState([]);

  // 获取跟单记录
  useEffect(() => {
    if (type === 3) {
      getFollowOrderHistory();
      isShowOrderButton.value = false;
    } else {
      isShowOrderButton.value = true;
    }
  }, [type]);

  // 获取跟单历史记录
  const getFollowOrderHistory = async () => {
    try {
      const result = await followApi.getHistoryOrders(uid);
      if (result.ok) {
        setFollowOrders(result.data || []);
      }
    } catch (error) {
      console.error('获取跟单记录失败:', error);
    }
  };

  // 处理跟单提交
  const handleFollowOrder = async () => {
    if (!orderCode.trim()) {
      Toast.show({
        content: translate(getText('請輸入')),
      });
      return;
    }

    try {
      // 调用跟单API
      const result = await requestPcMcdFollowOrder.fetch({
        fetchParams: {
          orderNo: orderCode.trim(),
          uid,
        },
      });

      if (result.ok) {
        Toast.show({
          content: translate(getText('跟單成功')),
        });
        setOrderCode('');
        getFollowOrderHistory();
      } else {
        Toast.show({
          content: result?.msg || translate(getText('操作失敗')),
        });
      }
    } catch (error) {
      Toast.show({
        content: translate(getText('操作失敗')),
      });
    }
  };

  const getNode = () => {
    hyorders = hyorders.filter((data) => data.coinname === tab);
    hyorders = hyorders.filter((data) => data.status === type);
    const nodes = [];
    for (let index = 0; index < hyorders.length; index++) {
      const data = hyorders[index];
      const node = (
        <div
          className="tradelistruning-2"
          onClick={() => {
            const sendData = {
              orderNo: data.orderNo,
              coinname: data.coinname,
              num: data.num,
              ploss: data.ploss,
              buytime: data.buytime,
              status: data.status,
              isWin: data.isWin,
            };
            if (data.status == 1 || data.status == 0) {
              return;
            }
            navigate(
              `/marketOrderInfo/${data.id}?data=${JSON.stringify(sendData)}`
            );
          }}
        >
          <div className="tradelistruning-3">
            <div className="tradelistruning-4">
              <div className="tradelistruning-5">
                <span className="tradelistruning-6">
                  {data.status == 0 && translate(getText('计划中'))}
                  {data.status == 1 && translate(getText('委托中'))}
                  {data.status == 2 && translate(getText('已完成'))}
                </span>
              </div>
              {showCancelButton && (
                <div
                  className="tradelistruning-7"
                  onClick={async () => {
                    const result = await contractApi.closeOrder({
                      orderNo: data.orderNo,
                    });
                    if (result.ok) {
                      navigate(0);
                    }
                  }}
                >
                  {translate(getText('撤銷單'))}
                </div>
              )}
              {/* <div className="tradelistruning-7">撤单</div> */}
            </div>
            <div className="tradelistruning-8">
              <div className="tradelistruning-9">
                <div className="tradelistruning-10">
                  <span className="tradelistruning-11">
                    {translate(getText('产品'))}
                  </span>
                </div>
                <div className="tradelistruning-12"> {data.coinname}</div>
              </div>
              <div className="tradelistruning-13">
                <div className="tradelistruning-14">
                  <span className="tradelistruning-15">
                    {translate(getText('方向'))}
                  </span>
                </div>
                <div
                  className={
                    data.hyzd == 1
                      ? 'tradelistruning-16'
                      : 'tradelistruning-16-1'
                  }
                >
                  {data.hyzd == 1
                    ? translate(getText('看涨'))
                    : translate(getText('看跌'))}
                </div>
              </div>
              <div className="tradelistruning-17">
                <div className="tradelistruning-18">
                  <span className="tradelistruning-19">
                    {translate(getText('时间周期'))}
                  </span>
                </div>
                <div className="tradelistruning-20">{data.time}</div>
              </div>
              <div className="tradelistruning-21">
                <div className="tradelistruning-22">
                  <span className="tradelistruning-23">
                    {translate(getText('数量'))}
                  </span>
                </div>
                <div className="tradelistruning-24"> {data.num.toFixed(2)}</div>
              </div>
              <div className="tradelistruning-25">
                <div className="tradelistruning-26">
                  <span className="tradelistruning-27">
                    {translate(getText('下单时间'))}
                  </span>
                </div>
                <div className="tradelistruning-28">
                  {data.plantime?.substring(0, 16)}
                </div>
              </div>
              {data.status == 0 && (
                <div className="tradelistruning-25">
                  <div className="tradelistruning-26">
                    <span className="tradelistruning-27">
                      {translate(getText('计划时间'))}
                    </span>
                  </div>
                  <div className="tradelistruning-28">
                    {formatDate(data.plantime)}
                  </div>
                </div>
              )}
              <div className="tradelistruning-29">
                <div className="tradelistruning-30">
                  <span className="tradelistruning-31">
                    {translate(getText('开仓价格'))}
                  </span>
                </div>
                <div className="tradelistruning-32"> {data.buyprice}</div>
              </div>
              {data.status != 0 && data.status != 1 && (
                <div className="tradelistruning-33">
                  <div className="tradelistruning-34">
                    <span className="tradelistruning-35">
                      {translate(getText('结算价格'))}
                    </span>
                  </div>
                  <div className="tradelistruning-36"> {data.sellprice}</div>
                </div>
              )}
              <div className="tradelistruning-33">
                <div className="tradelistruning-34">
                  <span className="tradelistruning-35">
                    {translate(getText('成交量'))}
                  </span>
                </div>
                <div className="tradelistruning-36"> {data.num.toFixed(2)}</div>
              </div>
              {data.status != 0 && data.status != 1 && (
                <div className="tradelistruning-33">
                  <div className="tradelistruning-34">
                    <span className="tradelistruning-35">
                      {translate(getText('亏盈'))}
                    </span>
                  </div>
                  <div className="tradelistruning-36">
                    {data.isWin == 1 ? '+' : '-'}
                    {data.ploss}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
      nodes.push(node);
    }
    if (nodes.length == 0) {
      nodes.push(<DataEmpty />);
    } else {
      nodes.push(
        <div
          style={{
            textAlign: 'center',
          }}
        >
          {translate(getText('暂无更多了'))}
        </div>
      );
    }
    return nodes;
  };

  // 渲染跟单内容
  const renderFollowContent = () => {
    return (
      <div className="follow-order-container pb-4">
        <div className="mb-8">
          <div className="border rounded-lg relative w-full flex items-center overflow-hidden shadow-sm transition-all duration-300 hover:shadow-md bg-white">
            {/* <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </span> */}
            <Input
              placeholder={`${translate(getText('請輸入'))} ${translate(
                getText('訂單號')
              )}`}
              value={orderCode}
              onChange={(val) => setOrderCode(val)}
              clearable
              className="p-2 pl-4 pr-24 w-full border-0 focus:ring-0"
              style={{
                height: '48px',
                fontSize: '14px',
              }}
            />
            <div className="absolute right-0 top-0 bottom-0 h-full flex items-center">
              <button
                onClick={handleFollowOrder}
                className="h-full px-4 text-blue-600 font-medium bg-blue-50 hover:bg-blue-100 transition-colors duration-300 flex items-center justify-center"
              >
                {translate(getText('跟单'))}
              </button>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <div className="flex items-center mb-4 pb-2 border-b border-gray-100">
            <span className="text-gray-800 font-medium">
              {translate(getText('歷史跟單'))}
            </span>
            <span className="ml-2 text-xs px-2 py-0.5 bg-gray-100 text-gray-500 rounded-full">
              {followOrders.length}
            </span>
          </div>
          <div className="flex flex-col">{renderFollowOrderHistory()}</div>
        </div>
      </div>
    );
  };

  // 渲染跟单记录内容
  const renderFollowOrderHistory = () => {
    if (followOrders.length === 0) {
      return (
        <div className="flex flex-col items-center justify-center py-12 text-gray-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mb-3 opacity-50"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="9" y1="9" x2="15" y2="9"></line>
            <line x1="9" y1="12" x2="15" y2="12"></line>
            <line x1="9" y1="15" x2="13" y2="15"></line>
          </svg>
          <div className="text-sm">{translate(getText('暫無數據'))}</div>
        </div>
      );
    }

    const nodes = followOrders.map((data, index) => (
      <div
        className="rounded-lg overflow-hidden border border-gray-100 shadow-sm follow-record-item bg-white"
        key={index}
      >
        <div className="border-b border-gray-50 px-4 py-3 flex justify-between items-center bg-gray-50 bg-opacity-50">
          <div className="flex items-center">
            <span
              className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                data.status == 0
                  ? 'bg-gray-100 text-gray-600'
                  : data.status == 1
                  ? 'bg-blue-50 text-blue-500'
                  : 'bg-green-50 text-green-500'
              }`}
            >
              {data.status == 0 && translate(getText('计划中'))}
              {data.status == 1 && translate(getText('委托中'))}
              {data.status == 2 && translate(getText('已完成'))}
            </span>
            <span className="ml-2 text-xs text-gray-400">
              #{data.orderNo?.substring(0, 8)}
            </span>
          </div>
          <div className="text-xs text-gray-400">
            {data.buytime?.substring(0, 16)}
          </div>
        </div>
        <div className="p-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col">
              <div className="text-gray-500 text-xs mb-1">
                {translate(getText('产品'))}
              </div>
              <div className="font-medium text-sm">{data.coinname}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-500 text-xs mb-1">
                {translate(getText('方向'))}
              </div>
              <div
                className={`text-sm font-medium ${
                  data.hyzd == 1 ? 'text-green-500' : 'text-red-500'
                }`}
              >
                {data.hyzd == 1
                  ? translate(getText('看涨'))
                  : translate(getText('看跌'))}
              </div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-500 text-xs mb-1">
                {translate(getText('数量'))}
              </div>
              <div className="font-medium text-sm">{data.num?.toFixed(2)}</div>
            </div>
            {data.status === 2 && (
              <div className="flex flex-col">
                <div className="text-gray-500 text-xs mb-1">
                  {translate(getText('亏盈'))}
                </div>
                <div
                  className={`font-bold text-sm ${
                    data.isWin == 1 ? 'text-green-500' : 'text-red-500'
                  }`}
                >
                  {data.isWin == 1 ? '+' : '-'}
                  {data.ploss}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    ));

    return (
      <div className="flex flex-col gap-4">
        {nodes}
        {followOrders.length > 0 && (
          <div className="text-center text-gray-400 text-xs py-4">
            {translate(getText('暂无更多了'))}
          </div>
        )}
      </div>
    );
  };

  function formatDate(dateTime) {
    const date = new Date(dateTime);
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let day = String(date.getDate()).padStart(2, '0');
    let hour = String(date.getHours()).padStart(2, '0');
    let minute = String(date.getMinutes()).padStart(2, '0');
    let second = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }
  return (
    <div style={{}}>
      <div className="tradechangebar-1 overflow-x-auto">
        <div className="tradechangebar-2">
          <div className="tradechangebar-3">
            <div
              className={type == 0 ? 'css-vtstzx' : 'tradechangebar-7'}
              onClick={() => {
                setType(0);
                setShowCancelButton(true);
              }}
            >
              <span className="tradechangebar-5 title-css-info">
                {translate(getText('计划订单'))}
              </span>
            </div>
          </div>
          <div className="tradechangebar-3">
            <div
              className={type == 1 ? 'css-vtstzx' : 'tradechangebar-7'}
              onClick={() => {
                setType(1);
                setShowCancelButton(false);
              }}
            >
              <span className="tradechangebar-5 title-css-info">
                {translate(getText('交割订单'))}
              </span>
            </div>
          </div>
          <div className="tradechangebar-6">
            <div
              className={type == 2 ? 'css-vtstzx' : 'tradechangebar-7'}
              onClick={() => {
                setType(2);
                setShowCancelButton(false);
              }}
            >
              <span className="tradechangebar-8 title-css-info">
                {translate(getText('历史订单'))}
              </span>
            </div>
          </div>
          <div className="tradechangebar-6">
            <div
              className={type == 3 ? 'css-vtstzx' : 'tradechangebar-7'}
              onClick={() => {
                setType(3);
                setShowCancelButton(false);
              }}
            >
              <span className="tradechangebar-8 title-css-info">
                {translate(getText('跟單交易'))}
              </span>
            </div>
          </div>
        </div>
        <div className="tradechangebar-12"></div>
      </div>
      <div
        className="overflow-x-hidden mb-8"
        style={{
          boxSizing: 'border-box',
          padding: '0 20px',
        }}
      >
        {type === 3 ? renderFollowContent() : getNode()}
      </div>
    </div>
  );
}
